import type { ReactElement } from "react";
import { CmtsAlertsContainer } from "../../core/containers/domain/systemRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsAlertsContainer runtime={props.runtime} />;
}

export default Component;
